import { get, post, put, deleted } from "../../index";
import IndustriesRoutes from "./Industries.routes";

const IndustriesServices = {
  getAllIndustries: async (page, limit) => {
    const result = await get(IndustriesRoutes.getAllIndustries + `?page=${page}&limit=${limit}`);
    return result;
  },

  createIndustry: async (obj) => {
    const result = await post(IndustriesRoutes.createIndustry, obj);
    return result;
  },

  updateIndustry: async (id, obj) => {
    const result = await put(IndustriesRoutes.updateIndustry + `/${id}`, obj);
    return result;
  },

  deleteIndustry: async (id) => {
    const result = await deleted(IndustriesRoutes.deleteIndustry + `/${id}`);
    return result;
  },
}

export default IndustriesServices;